/**
 * DashboardActivitiesRecentRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { DashboardActivityOutput } from './dashboard_activity_output'

/**
 * DashboardActivitiesRecentRes
 */
export interface DashboardActivitiesRecentRes {
  /** 活动列表 */
  list?: DashboardActivityOutput[]
}

/**
 * DashboardActivitiesRecentRes Schema
 */
export const DashboardActivitiesRecentResSchema: SchemaDefinition = {
  properties: {
    list: {
      description: '活动列表',
      format: '[]*service.DashboardActivityOutput',
      items: { $ref: 'DashboardActivityOutput', description: '' },
      type: 'array',
      label: '活动列表',
    },
  },
  type: 'object',
}
